// extracted by mini-css-extract-plugin
export default {"no-data-container":"NoResultAnalytics_no-data-container__Hcc1V","no-data-content":"NoResultAnalytics_no-data-content__6CaBC","label":"NoResultAnalytics_label__Y5rmH"};